import { Text } from 'platform/foundation-tw';
import { CellRendererProps } from '../../types/CellRendererProps';
type FileEntry = {
  title?: string;
};
type FilePlainCellRendererProps = CellRendererProps<unknown>;
export function FilePlainCellRenderer(props: FilePlainCellRendererProps) {
  const values = props.value as FileEntry | undefined;
  return <Text size="small">{values?.title}</Text>;
}